_BannerFlowApp.directive("tagsInput", function ($timeout, $http, AuthInfo, Brand) {
    return {
        restrict: "E",
        template:
            '<div class="tags-wrapper" tooltip="{{ tooltipText || \'Use labels to tag your banner sets and make them easier to locate.\'}}" tooltip-side="left"><input type="hidden"  placeholder="{{ placeholder || \'Add labels...\' }}"></div>',
        replace: true,
        scope: {
            labels: "=?",
            type: "@?",
            placeholder: "@?",
            tooltipText: "@?"
        },
        require: "?ngModel",
        link: function (scope, element, attrs, ngModel) {
            scope.type = scope.type || "campaign";

            var drivenByModel = false;

            var setup = function (data) {
                var rawData = new Array();

                _.each(data, function (o) {
                    rawData.push(o);
                });

                _.each(ngModel.$viewValue, function (o) {
                    $("input", element).val($("input", element).val() + o + ",");
                });

                element.css("visible", "visible");

                var tagsinput = $("input", element).tagsinput({
                    typeahead: {
                        source: rawData
                    }
                });

                $("input", element).on("change", function (e) {
                    var tags = $("input", element).val().split(",");
                    var saveTags = new Array();

                    _.each(tags, function (tag) {
                        var realTag = _.find(data, function (t) {
                            return t === tag;
                        });

                        if (!realTag) {
                            saveTags.push(tag);
                        } else {
                            saveTags.push(realTag);
                        }
                    });

                    var save = function () {
                        ngModel.$setViewValue(saveTags);
                    };

                    scope.$apply(save);
                });
            };

            element.css("visible", "hidden");

            if (!scope.labels) {
                Brand.getLabels(function (data) {
                    setup(data);
                });
            } else {
                $timeout(function () {
                    setup(angular.copy(scope.labels));
                });
            }
        }
    };
});
